import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import SubCard from "../../../components/ui-component/card/SubCard";
import { gridSpacing } from "../../../store/constant";
import { useState } from "react";
import { useEffect } from "react";
import CustomSnackbar from "../../../components/ui-component/snackbar/CustomSnackbar";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function ProgramEnrolPage({ studentDetails, onNext }) {
  const userId = localStorage.getItem("userId");
  const [selectedSubService, setSelectedSubService] = useState(
    studentDetails?.subServiceId || null,
  );
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedProgram, setSelectedProgram] = useState(
    studentDetails?.scholarsProgramId || null,
  );
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [programs, setPrograms] = useState([]);
  const [packages, setPackages] = useState([]);
  const [installments, setInstallments] = useState([]);
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const [selectedMonthIntake, setSelectedMonthIntake] = useState("");
  const [selectedYearIntake, setSelectedYearIntake] = useState("");
  const [months, setMonths] = useState([]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    fetch(
      `${API_ENDPOINT}route2.0/getprogramsbysubservice/${studentDetails?.subServiceId}`,
    )
      .then((response) => response.json())
      .then((data) => {
        setPrograms(data);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
        setPrograms([]);
      });
  }, [studentDetails]);

  useEffect(() => {
    fetch(`${API_ENDPOINT}month`)
      .then((response) => response.json())
      .then((data) => {
        setMonths(data);
      })
      .catch((error) => {
        console.error("Error fetching months:", error);
        setMonths([]);
      });
  }, []);

  const handleProgramChange = (event) => {
    setSelectedProgram(event.target.value);
    setSelectedClass(null);
    setSelectedPackage(null);
    setSelectedInstallment(null);
  };

  //    useEffect(() => {
  //   const fetchPackages = async () => {
  //     try {
  //       const response = await fetch(`${API_ENDPOINT}package/fetch/packagesbyprogramandclass`, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify({
  //           scholars_program_id: selectedProgram,
  //           ...(selectedClass && { scholars_class: selectedClass})
  //         }),
  //       });

  //       if (!response.ok) {
  //         const err = await response.json();
  //         throw new Error(err.message || 'Failed to fetch packages');
  //       }

  //       const data = await response.json();
  //       setPackages(data);
  //     } catch (err) {

  //     }
  //   };

  //   if (selectedProgram) {
  //     fetchPackages();
  //   }
  // }, [selectedProgram, selectedClass]);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}package/fetch/packagesbyprogramclassandbranch`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              user_id: parseInt(userId),
              scholars_program_id: selectedProgram,
              ...(selectedClass && { scholars_class: selectedClass }),
            }),
          },
        );

        if (!response.ok) {
          const err = await response.json();
          throw new Error(err.message || "Failed to fetch packages");
        }

        const data = await response.json();
        setPackages(data);
      } catch (err) {}
    };

    if (selectedProgram) {
      fetchPackages();
    }
  }, [selectedProgram, selectedClass]);

  const handlePackageChange = (event) => {
    const selectedPackageId = event.target.value;
    const selectedPackage = packages.find(
      (pack) => pack.id === selectedPackageId,
    );

    setSelectedPackage(selectedPackage);
    setInstallments(
      Array.from(
        { length: selectedPackage?.payable_installment },
        (_, index) => index + 1,
      ),
    );
  };

  const handleMonthIntakeChange = (event) => {
    setSelectedMonthIntake(event.target.value);
  };

  const handleYearIntakeChange = (event) => {
    setSelectedYearIntake(event.target.value);
  };

  const currentYear = new Date().getFullYear();
  const intakeYears = Array.from({ length: 5 }, (_, i) => currentYear + i);

  const validateForm = () => {
    if (!selectedProgram) {
      showSnackbar("Please select a program", "error");
      return false;
    }

    if (!selectedPackage) {
      showSnackbar("Please select a package", "error");
      return false;
    }

    if (!selectedMonthIntake || selectedMonthIntake == "") {
      showSnackbar("Please select the month intake", "error");
      return false;
    }

    if (!selectedYearIntake || selectedYearIntake == "") {
      showSnackbar("Please select the year intake", "error");
      return false;
    }

    // Check if the selected month and year is in the past
    const selectedDate = new Date(
      `${selectedMonthIntake} 1, ${selectedYearIntake}`,
    );
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    if (selectedDate < now) {
      showSnackbar(
        "The selected month and year intake cannot be current month or in the past",
        "error",
      );
      return false;
    }

    return true;
  };

  const handleContinueClick = () => {
    if (validateForm()) {
      onNext(
        selectedProgram,
        selectedPackage,
        selectedInstallment,
        selectedMonthIntake,
        selectedYearIntake,
      );
    } else {
      console.log("Form validation failed");
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <SubCard title="Select Program">
          <Box m={2}>
            <Grid container spacing={gridSpacing}>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <Typography variant="h6">Select Program</Typography>
                  <Select
                    size="normal"
                    name="scholars_program_id"
                    value={selectedProgram}
                    onChange={handleProgramChange}
                    required
                    style={{ borderRadius: "10px" }}
                  >
                    {programs.length === 0 ? (
                      <MenuItem value="">
                        {" "}
                        No programs found for this sub service
                      </MenuItem>
                    ) : (
                      programs.map((pack) => (
                        <MenuItem key={pack.id} value={pack.id}>
                          {pack.name}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>

              {selectedProgram == 4 && (
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <Typography variant="h6">Select Class</Typography>
                    <Select
                      size="normal"
                      name="scholars_class"
                      value={selectedClass}
                      onChange={(e) => setSelectedClass(e.target.value)}
                      required
                      style={{ borderRadius: "10px" }}
                    >
                      <MenuItem value="class_11">Class 11</MenuItem>
                      <MenuItem value="class_12">Class 12</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {selectedProgram == 5 && (
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <Typography variant="h6">Select Class</Typography>
                    <Select
                      size="normal"
                      name="scholars_class"
                      value={selectedClass}
                      onChange={(e) => setSelectedClass(e.target.value)}
                      required
                      style={{ borderRadius: "10px" }}
                    >
                      <MenuItem value="class_9">Class 9</MenuItem>
                      <MenuItem value="class_10">Class 10</MenuItem>
                      <MenuItem value="class_11">Class 11</MenuItem>
                      <MenuItem value="class_12">Class 12</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <Typography variant="h6">Select Month Intake</Typography>
                  <Select
                    size="normal"
                    name="sap_month_intake"
                    value={selectedMonthIntake}
                    onChange={handleMonthIntakeChange}
                    required
                    style={{ borderRadius: "10px" }}
                  >
                    {months.map((pack) => (
                      <MenuItem key={pack.id} value={pack.id}>
                        {pack.month_full_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <Typography variant="h6">Select Year Intake</Typography>
                  <Select
                    size="normal"
                    name="sap_year_intake"
                    value={selectedYearIntake}
                    onChange={handleYearIntakeChange}
                    required
                    style={{ borderRadius: "10px" }}
                  >
                    {intakeYears.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </SubCard>
      </Grid>

      <Grid item xs={12}>
        <SubCard title="Select Package">
          <Box m={2}>
            <Grid container spacing={gridSpacing}>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <Typography variant="h6">Select Package</Typography>
                  <Select
                    size="normal"
                    name="package_id"
                    value={selectedPackage ? selectedPackage.id : null}
                    onChange={handlePackageChange}
                    required
                    style={{ borderRadius: "10px" }}
                  >
                    {packages.length === 0 ? (
                      <MenuItem value="">
                        {" "}
                        No packages found for this program
                      </MenuItem>
                    ) : (
                      packages.map((pack) => (
                        <MenuItem key={pack.id} value={pack.id}>
                          {pack.package_name}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <Typography variant="h6">Payable Installmentszz</Typography>
                  <Select
                    size="normal"
                    name="payable_installments"
                    value={selectedInstallment}
                    onChange={(e) => setSelectedInstallment(e.target.value)}
                    required
                    style={{ borderRadius: "10px" }}
                  >
                    {installments.map((installment) => (
                      <MenuItem key={installment} value={installment}>
                        {installment}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </SubCard>
      </Grid>

      <Grid container justifyContent="right" spacing={0} mt={2}>
        <Grid item>
          <Button
            variant="contained"
            color="secondary"
            size="medium"
            onClick={handleContinueClick}
          >
            Continue
          </Button>
        </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}

export default ProgramEnrolPage;
